export default {
    data: {},
    virtualBank: {},
};
